import React from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer';

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function showImageOrPdf(docUrl, heightOfDoc) {
  if (docUrl?.substr(docUrl?.length - 4) === '.pdf') {
    return (
      <div className={'cursor-pointer'} onClick={() => {
        window.open(docUrl, '_blank');
      }}>
        <Document file={docUrl}>
          <Page
            pageNumber={1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            height={heightOfDoc * 16}
          />
        </Document>
      </div>
    );
  }

  if (docUrl) {
    return (
      <React.Fragment>
        <div className={'cursor-pointer'} onClick={() => {
          window.open(docUrl, '_blank');
        }}>
         <Document file={docUrl}>
            <Page
              pageNumber={1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              height={heightOfDoc * 16}
            />
          </Document>
        </div>

        <img className='h-[8rem] cursor-pointer object-cover' onClick={() => {
          window.open(docUrl, '_blank');
        }} src={docUrl} alt='doc' />
      </React.Fragment>
    );
  }

  return <div className='italic'>no image</div>;
}

export const drugReorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
